import { CheckboxField, NumberField, BooleanField, RadioField, StringField, MonthPicker } from './FieldForm/components';
import { isUnlock } from './FieldForm/utils';
export var FIELDS_TYPES = {
  date: {
    component: MonthPicker,
    validator: function validator(field, value) {
      return isUnlock(field, value);
    }
  },
  checkbox: {
    component: CheckboxField,
    validator: function validator(field, value) {
      return isUnlock(field, value);
    }
  },
  number: {
    component: NumberField,
    validator: function validator(field, value) {
      return isUnlock(field, value);
    }
  },
  boolean: {
    component: BooleanField,
    validator: function validator(field, value) {
      return isUnlock(field, value);
    }
  },
  radio: {
    component: RadioField,
    validator: function validator(field, value) {
      return isUnlock(field, value);
    }
  },
  string: {
    component: StringField,
    validator: function validator(field, value) {
      return isUnlock(field, value);
    },
    props: {
      textAlign: 'center'
    }
  }
};